import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Badge, Card, Col, Form, Offcanvas, Row, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../Pagination";
import UseToggle from "../../../Hooks/UseToggle";
import UpdateStudyRandomizationSchema from "./UpdateStudyRandomizationSchema";
import AddNewStudyRandomizationSchema from "./AddNewStudyRandomizationSchema";
import DeletedStudyRandomizationSchema from "./DeletedStudyRandomizationSchema";
import StudyRandomizationSchemaActivities from "./StudyRandomizationSchemaActivities";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import { studyTreatmentManagementServices } from "../../../APIServices/CTMS/studyTreatmentManagementServices";
import { GoEye, GoEyeClosed } from "react-icons/go";
import UpdateStudyRandomizationSchemaSeedNumber from "./UpdateStudyRandomizationSchemaSeedNumber";

const StudyRandomizationSchemaDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [randomizationSchemaData, setRandomizationSchemaData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [randomizationSchemaList, setRandomizationSchemaList] = useState([]);
  const [randomizationSchemaCount, setRandomizationSchemaCount] = useState(0);
  const [deletedStudySiteRandomizationSchema, setDeletedStudyRandomizationSchema] = useState([]);
  const [deletedStudySiteRandomizationSchemaCount, setDeletedStudyRandomizationSchemaCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [randomizationSchemaId, setRandomizationSchemaId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [randomizationSchemaActivity, setRandomizationSchemaActivity] = useState([]);
  const [randomizationSchemaActivityCount, setRandomizationSchemaActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [treatmentList, setTreatmentList] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyTreatmentRowData = async () => {
    let data = await studyTreatmentManagementServices.getStudyTreatmentRowData(
      "active",
      studyId
    );
    let initialData = Object.values(data?.data === undefined ? "" : data?.data);
    let finalData = initialData?.sort()?.reverse();
    setTreatmentList(finalData);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(2);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(randomizationSchemaCount / itemsPerPage);

  const getEIWRSRandomizationSchemaData = async (e) => {
    setLoading(true);
    let data = await eiwrsRandomizationSchemaServices.getEIWRSRandomizationSchemaData(
      "active",
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setRandomizationSchemaList(data?.data || []);
    setRandomizationSchemaCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSRandomizationSchemaData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsRandomizationSchemaServices.getEIWRSRandomizationSchemaData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyRandomizationSchema(data?.data || []);
    setDeletedStudyRandomizationSchemaCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSRandomizationSchema",
      studyId,
      randomizationSchemaData?.schemaId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setRandomizationSchemaActivity(data?.data || []);
    setRandomizationSchemaActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [randomizationSchemaData]);

  useEffect(() => {
    getStudyTreatmentRowData()
  }, []);

  useEffect(() => {
    getEIWRSRandomizationSchemaData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSRandomizationSchema = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Randomization Schema!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsRandomizationSchemaServices.softDeleteRestoreEIWRSRandomizationSchema(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSRandomizationSchemaData();
          setRandomizationSchemaId("");
          getDeletedEIWRSRandomizationSchemaData();
          if (type === "restore") {
            getDeletedEIWRSRandomizationSchemaData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  console.log("randomizationSchemaList>>>>>>>", randomizationSchemaList);
  

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {StudyMode === "DBP Mode" &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setRandomizationSchemaId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {randomizationSchemaCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteRandomizationSchemaCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSRandomizationSchemaData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={20}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        defaultSize={isFormOpen ? "20%" : "100%"}
      >
        {isFormOpen && (
          <AddNewStudyRandomizationSchema treatmentList={treatmentList} getEIWRSRandomizationSchemaData={getEIWRSRandomizationSchemaData} />
        )}
        {loading ? (
          <PageLoader />
        ) : randomizationSchemaCount === 0 ? (
          <NoDataFoundTable MSG={"Study Randomization Schema not found!"} />
        ) : randomizationSchemaList?.length === 0 ? (
          <NoDataFoundTable MSG={"Search Study Randomization Schema not found!"} />
        ) : (
          <>
            <div className="p-2">
              <Row className="g-3">
                {randomizationSchemaList?.map((schema, index) => {
                  return (
                    <Col key={schema._id} xs={12} md={6} xl={4}>
                      <Card className="app-card h-100 shadow-sm border-0">
                        <Card.Body>
                          <div>
                            <div className="d-flex justify-content-between">
                              <div>
                                <h6 className="mb-1">{schema?.schemaName}</h6>
                                {schema?.randomizationType != "assignBased" &&
                                  <Form.Label className="mb-1">
                                    Seed Number: {schema?.seedNumber || "______________"}
                                  </Form.Label>
                                }
                                <Form.Label className="mb-1">
                                  Type: {schema?.randomizationType === "assignBased" ? "Assign Based Randomization" : schema?.randomizationType === "doseesc" ? "Dose-Escalation" : schema?.randomizationType === "block" ? "Block" : `${schema?.randomizationType}`}
                                </Form.Label>
                              </div>
                              <div>
                                <Badge
                                  bg="success-subtle"
                                  style={{ fontSize: 10 }}
                                  className={`br3 text-success border border-success px-2 text-capitalize mx-2`}
                                >
                                  Active
                                </Badge>
                              </div>
                            </div>
                            {schema?.randomizationType != "assignBased" &&
                              <>
                                {(schema?.treatmentRatio || [])?.length > 0 &&
                                  <Table className="mt-3 m-0 custom-table" hover>
                                    <thead className="">
                                      <tr>
                                        <th>Treatment</th>
                                        <th>Ratio</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(schema?.treatmentRatio || [])?.map((treat, key) => (
                                        <tr key={index}>
                                          <td className="font-monospace">{treat?.treatmentId}</td>
                                          <td>{treat?.ratio}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                }
                              </>
                            }
                            {schema?.description &&
                              <Form.Label className="text-muted small mt-2">
                                {schema?.description}
                              </Form.Label>
                            }
                          </div>
                          {schema?.randomizationType != "assignBased" &&
                            <div className="d-flex justify-content-between small border-top pt-2">
                              {schema?.randomizationType === "simple" ?
                                <div>
                                  <span className="text-muted">No of Subject</span>
                                  <div className="fw-bold text-center">{schema?.numberOfSubject}</div>
                                </div>
                                :
                                <div>
                                  <span className="text-muted">No of Block</span>
                                  <div className="fw-bold text-center">{schema?.numberOfBlock}</div>
                                </div>
                              }
                              <div>
                                <span className="text-muted">Blinded</span>
                                <div className="fw-bold text-center">{schema?.blinded ? "Yes" : "No"}</div>
                              </div>
                              <div>
                                <span className="text-muted">Level</span>
                                <div className="fw-bold text-center">{schema?.level === "studyLevel" ? "Study" : "Site"}</div>
                              </div>
                            </div>
                          }
                        </Card.Body>
                        <Card.Footer className="bg-white border-top">
                          <div className="d-flex justify-content-between">
                            <div className="hstack gap-2">
                              <button
                                className="updateProfile"
                                style={{ fontSize: 11 }}
                                onClick={() => {
                                  setRandomizationSchemaData(schema);
                                  setRandomizationSchemaId(schema?._id);
                                  setToggle2();
                                }}
                              >
                                Activities
                              </button>
                            </div>
                            <div className="hstack gap-2">
                              {schema?.randomizationType != "assignBased" &&
                                <button
                                  disabled={schema?.seedDisabed}
                                  className="updateProfile"
                                  title={`Update ${schema?.randomizationSchema}`}
                                  onClick={(e) => {
                                    setRandomizationSchemaData(schema);
                                    setToggle3();
                                    e.stopPropagation();
                                  }}
                                >
                                  Update Seed Number
                                </button>
                              }
                              {StudyMode === "DBP Mode" &&
                                <>
                                  <button
                                    className="updateProfile"
                                    title={`Update ${schema?.schemaName}`}
                                    onClick={(e) => {
                                      setRandomizationSchemaData(schema);
                                      setToggle();
                                      e.stopPropagation();
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    className="removeProfile"
                                    title={`Delete ${schema?.schemaName}`}
                                    onClick={(e) => {
                                      softDeleteRestoreEIWRSRandomizationSchema(
                                        schema?._id,
                                        "delete"
                                      );
                                    }}
                                  >
                                    Delete
                                  </button>
                                </>
                              }
                            </div>
                          </div>
                        </Card.Footer>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={randomizationSchemaCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
      <UpdateStudyRandomizationSchema
        Show={!toggle}
        Hide={setToggle}
        treatmentList={treatmentList}
        randomizationSchemaData={randomizationSchemaData}
        setRandomizationSchemaId={setRandomizationSchemaId}
        getEIWRSRandomizationSchemaData={getEIWRSRandomizationSchemaData}
        Title={`Update ${randomizationSchemaData?.schemaName}`}
      />
      <UpdateStudyRandomizationSchemaSeedNumber
        Show={!toggle3}
        Hide={setToggle3}
        randomizationSchemaData={randomizationSchemaData}
        setRandomizationSchemaId={setRandomizationSchemaId}
        getEIWRSRandomizationSchemaData={getEIWRSRandomizationSchemaData}
        Title={`Update ${randomizationSchemaData?.schemaName}`}
      />
      <DeletedStudyRandomizationSchema
        Show={!toggle1}
        Hide={setToggle1}
        setRandomizationSchemaId={setRandomizationSchemaId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteRandomizationSchema={deletedStudySiteRandomizationSchema}
        getDeletedEIWRSRandomizationSchemaData={getDeletedEIWRSRandomizationSchemaData}
        deletedStudySiteRandomizationSchemaCount={deletedStudySiteRandomizationSchemaCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSRandomizationSchema={softDeleteRestoreEIWRSRandomizationSchema}
        Title={`Deleted ${randomizationSchemaData?.schemaName}`}
      />
      <Offcanvas
        show={!toggle2}
        onHide={setToggle2}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Activity - {randomizationSchemaData?.schemaName}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <StudyRandomizationSchemaActivities
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            randomizationSchemaActivity={randomizationSchemaActivity}
            activityLoader={activityLoader}
            getStudyAuditTrials={getStudyAuditTrials}
            randomizationSchemaData={randomizationSchemaData}
            randomizationSchemaActivityCount={randomizationSchemaActivityCount}
            isFullScreen={isFullScreen}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default StudyRandomizationSchemaDataList;
